import React, { useEffect } from 'react'

import LeaguesTypeIcon from '../common/LeaguesTypeIcon'
import BigRadioButton from './BigRadioButton'
import { GlgDisabledElementWrapper, GlgSelect, GlgTextInput } from '../../../shared/components'
import {
  mapToDropdown,
  selectLeaguesProductTypes,
  selectProductType,
  selectTextSearch,
  setProductType,
  setTextSearch,
  withAllEntry,
} from '../../reducers/leagues_filter_values'
import { useDispatch, useSelector } from 'react-redux'
import useSessionSaver from '../../hooks/useSessionSaver'
import { setLeagueForDatePicking, selectLeagueForDatePicking } from '../../reducers/leagues_dates'


export default function LeaguesDatesList() {
  const dispatch = useDispatch()

  const { leaguesForDatePicking } = useSessionSaver()
  const leagueForDatePicking = useSelector(selectLeagueForDatePicking)

  const productTypes = withAllEntry(useSelector(selectLeaguesProductTypes))
  const productType = useSelector(selectProductType)
  const textSearch = useSelector(selectTextSearch)
  const handleTextSearchChange = (value) => {
    dispatch(setTextSearch(value))
  }

  useEffect(() => {
    if (
      Object.keys(leaguesForDatePicking).length &&
      !Object.keys(leaguesForDatePicking).includes(leagueForDatePicking?.id)
    ) {
      dispatch(setLeagueForDatePicking(null))
    }
  }, [ leagueForDatePicking, leaguesForDatePicking ])

  return (
    <div className={'cls-ld-list'}>
      <span className={'cls-ld-list__title'}>
        {window.I18n.t('clone_leagues_sessions.general.select_an_event')}
      </span>
      <span className={'cls-ld-list__filters-container'}>
          <span className={'cls-ld-list__filter-product'}>
             {window.I18n.t('clone_leagues_sessions.general.type')}
            <span className='cls-ld-list__product-input'>
              <GlgSelect
                items={mapToDropdown(productTypes)}
                value={productType}
                selectorClassName={'dropdown-select'}
                onChange={(option) => { dispatch(setProductType(option)) }}
              />
            </span>
          </span>
          <span className={'cls-ld-list__name-input'}>
            <GlgTextInput
              onChange={handleTextSearchChange}
              value={textSearch}
              withAddon
            />
          </span>

        </span>
      <div className={'cls-ld-list__container'}>
        {Object.entries(leaguesForDatePicking).map(([ _, league ], index) => {
          const hasRounds = (league?.rounds?.length ?? 0) > 0
          const isSelected = leagueForDatePicking?.id === league.id
          const row = (
            <div
              key={league.id}
              onClick={hasRounds ? () => dispatch(setLeagueForDatePicking(league)) : undefined}
              className={isSelected ? 'item selected' : 'item'}
            >
              {hasRounds
                ? <BigRadioButton selected={isSelected} onClick={() => {}} />
                : <BigRadioButton selected={false} onClick={() => {}} />
              }
              <span className={'item-number'}>{index + 1}.</span>
              <span className={isSelected ? 'item-name selected' : 'item-name'}>
                {league.league_name}
              </span>
              <span className={'item-rounds'}>
                {hasRounds
                  ? <span>{window.I18n.t(
                      'clone_leagues_sessions.general.fraction',
                      {x: league?.mass_dates?.length ?? 0, y: league?.rounds?.length},
                    )} {window.I18n.t('clone_leagues_sessions.general.rounds')}</span>
                  : <span>{window.I18n.t('clone_leagues_sessions.general.no_rounds')}</span>
                }
              </span>
              <span className={'item-type'}>
                <LeaguesTypeIcon leagueType={league.product} />
              </span>
            </div>
          )

          return (<GlgDisabledElementWrapper key={league.id} disabled={!hasRounds}>{row}</GlgDisabledElementWrapper>)
        })}
      </div>
    </div>
  )
}
